import type { LocalSort, PageMatch } from './api';

const numFmt = new Intl.NumberFormat('it-IT');
export const MAX_MONITORED_PAGES = 10;

interface Props {
  rows: PageMatch[];
  selected: string[];
  sort: LocalSort;
  onToggle: (pageId: string) => void;
  onToggleAll: (pageIds: string[]) => void;
  onOpen: (pageId: string, pageName: string) => void;
}

export default function CompanyResults({ rows, selected, sort, onToggle, onToggleAll, onOpen }: Props) {
  const ordered = [...rows].sort((a, b) => {
    if (sort === 'reach') return b.totalReach - a.totalReach || b.adsCount - a.adsCount;
    if (sort === 'days') return (b.avgDays ?? 0) - (a.avgDays ?? 0) || b.adsCount - a.adsCount;
    if (sort === 'startTime') return new Date(b.lastSeenAt ?? 0).getTime() - new Date(a.lastSeenAt ?? 0).getTime();
    return b.adsCount - a.adsCount || new Date(b.lastSeenAt ?? 0).getTime() - new Date(a.lastSeenAt ?? 0).getTime();
  });
  const selectable = ordered.slice(0, MAX_MONITORED_PAGES);
  const allSelected = selectable.length > 0 && selectable.every((row) => selected.includes(row.pageId));

  return <section className="company-results" aria-labelledby="company-results-title">
    <header className="company-results-head">
      <div><h2 id="company-results-title">Pagine trovate</h2><p>Apri tutti gli annunci oppure seleziona fino a {MAX_MONITORED_PAGES} pagine da monitorare.</p></div>
      <label className="select-all"><input type="checkbox" checked={allSelected} onChange={() => onToggleAll(selectable.map((row) => row.pageId))} /><span>{rows.length > MAX_MONITORED_PAGES ? `Seleziona prime ${MAX_MONITORED_PAGES}` : 'Seleziona tutte'}</span></label>
    </header>
    <div className="company-list">
      {ordered.map((row) => {
        const name = row.pageName ?? row.pageId;
        const initial = name.trim().slice(0, 2).toUpperCase();
        const checked = selected.includes(row.pageId);
        const activeRate = row.adsCount > 0 ? Math.round(row.activeCount / row.adsCount * 100) : 0;
        return <article className={checked ? 'company-row is-selected' : 'company-row'} key={row.pageId}>
          <label className="company-check"><input type="checkbox" checked={checked} disabled={!checked && selected.length >= MAX_MONITORED_PAGES} onChange={() => onToggle(row.pageId)} /><span className="sr-only">Seleziona {name} per il monitoraggio</span></label>
          <button type="button" className="company-open" onClick={() => onOpen(row.pageId, name)}>
            <span className="company-avatar" aria-hidden="true">{initial}</span>
            <span className="company-identity"><strong>{name}</strong><small>{numFmt.format(row.adsCount)} annunci · {numFmt.format(row.activeCount)} attivi</small></span>
            <span className="company-arrow" aria-hidden="true"><span>Vedi annunci</span><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="m7.5 4.5 5 5.5-5 5.5"/></svg></span>
          </button>
          <div className="company-activity" aria-label={`${activeRate}% degli annunci osservati è attivo`}><span><i style={{ width: `${activeRate}%` }} /></span></div>
          <dl className="company-metrics"><div><dt>Reach</dt><dd>{row.totalReach > 0 ? numFmt.format(row.totalReach) : 'n/d'}</dd></div><div><dt>Durata media</dt><dd>{row.avgDays ? `${Math.round(row.avgDays)} giorni` : 'n/d'}</dd></div></dl>
        </article>;
      })}
    </div>
  </section>;
}
